import React from "react";
import { CreditCard, ArrowUpRight } from "lucide-react";

export const ACORN_URL = "https://www.acornfinance.com/pre-qualify/?d=KSG0E&utm_medium=web_pre_qual_link";
export const trackFinancing = (source) => {
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/financing-click?source=${encodeURIComponent(source)}`, { method: "POST", keepalive: true }).catch(() => {});
};
export const FINANCING_TEXT = "Financing available through Acorn Finance. Monthly payments on approved credit.";

export const FinancingBand = ({ testId = "financing-band", className = "bg-[#eef4ff] border-y border-[#3b9dff]/20", dark = false, inner = "max-w-[1100px] mx-auto px-5 lg:px-8" }) => (
  <section data-testid={testId} className={className}>
    <div className={`${inner} py-5 flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between`}>
      <p className={`flex items-center gap-3 font-semibold ${dark ? "text-white" : "text-[#0a1f44]"}`}>
        <CreditCard className="w-5 h-5 text-[#3b9dff] shrink-0" />
        <span data-testid={`${testId}-text`}>{FINANCING_TEXT}</span>
      </p>
      <a href={ACORN_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackFinancing(testId)} data-testid={`${testId}-apply-btn`}
        className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-white font-bold text-sm transition-colors shrink-0 ${dark ? "bg-[#3b9dff] hover:bg-[#2b8ae8]" : "bg-[#0a1f44] hover:bg-[#13306a]"}`}>
        Apply for financing <ArrowUpRight className="w-4 h-4" />
      </a>
    </div>
  </section>
);
